module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab124-708ffe986c184e2e71b69667c9715924.jpg";